import { render, staticRenderFns } from "./PriceImport.vue?vue&type=template&id=fece8fe0&"
import script from "./PriceImport.vue?vue&type=script&lang=js&"
export * from "./PriceImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports